import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Container
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const SubmissionSuccess = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 4
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        
        <Typography variant="h4" component="h1" gutterBottom>
          Thank You!
        </Typography>
        
        <Typography variant="h6" gutterBottom>
          Your response has been successfully submitted.
        </Typography>
        
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mt: 3,
            mb: 4,
            maxWidth: '600px',
            width: '100%',
            bgcolor: 'success.light',
            color: 'success.contrastText'
          }}
        >
          <Typography variant="body1">
            We have received your submission and will process it shortly.
            You may close this window or return to the home page.
          </Typography>
        </Paper>
        
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/"
          sx={{ mt: 2 }}
        >
          Return to Home
        </Button>
      </Box>
    </Container>
  );
};

export default SubmissionSuccess;
